import { combineReducers } from 'redux';

import results from './results/reducer';

export default combineReducers({
  results
});



/** WEBPACK FOOTER **
 ** ./src/members/state/search/paging/reducer.js
 **/